export const GoogleMapApiConfig = 'AIzaSyBByoGS9fX_DpIoQRlv7oJEL9Lk5BkLyBw';